<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <RowColumn v-if="canPurchaseProducts()" class="container pt-3">
            <ButtonTag :is-w100="false" :is-tw-main-btn="true" url="write-off">
                <div class="pt-1">{{ $t('productsInWarehouse.writeOff') }}</div>
            </ButtonTag>
        </RowColumn>

        <Modal
            :text="modalItemReason"
            :title="modalItemAmount + ' ' + modalItemMeasure + ' ' + modalItemName + ':'"
            :hide-header="false"
            id="modal_show"
        />

        <SearchCollapse class="container pr-3" :is-bg-white="true">
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('product.name') }}
                    </div>
                    <b-form-input
                        v-model="search.productName"
                        class="h-11 border-gray-300 focus:ring-0"
                        @keyup.enter="searchProduct"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('warehouse.name') }}
                    </div>
                    <b-form-input
                        v-model="search.warehouseName"
                        class="h-11 border-gray-300 focus:ring-0"
                        @keyup.enter="searchProduct"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('category') }}
                    </div>
                    <TreeCheckBox
                        sm-size="12"
                        md-size="12"
                        model-name="category"
                        :model-form="search"
                        :options="this.getProductCategoriesTree"
                        :multiple="false"
                        :no-margin-top="true"
                        class="p-0 d-flex"
                    />
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.fromAmount') }}
                    </div>
                    <b-form-input
                        v-model="search.minAmount"
                        class="h-11 border-gray-300 focus:ring-0"
                        type="number"
                        @keyup.enter="searchProduct"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                        {{ $t('filter.toAmount') }}
                    </div>
                    <b-form-input
                        v-model="search.maxAmount"
                        class="h-11 border-gray-300 focus:ring-0"
                        type="number"
                        @keyup.enter="searchProduct"
                    >
                    </b-form-input>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative">
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                        <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchProduct">
                    </button>
                    <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                        <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductInWarehousesInfo">
                    </button>
                </div>
            </div>
        </SearchCollapse>


        <!-- ProductsList component -->
        <table class="w-full mt-3">
            <thead class="bg-lightGray h-11 font-bold">
            <tr>
                <th class="d-none d-sm-table-cell pl-2">#</th>
                <th>{{ $t('product.title') }}</th>
                <th class="d-none d-sm-table-cell">{{ $t('image.title') }}</th>
                <th>{{ $t('warehouse.title') }}</th>
                <th>{{ $t('productsInWarehouse.reason') }}</th>
                <th>{{ $t('amount') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in getProductsInWarehousesWriteOffs" v-bind:key="index" class="h-11 border-bottom">
                <td class="d-none d-sm-table-cell">{{ index + 1 }}</td>
                <td class="text-main font-bold">{{ item.product.product.name }}</td>
                <td class="d-none d-sm-table-cell">
                    <img :src="item.product.product.image ? url + item.product.product.image.contentUrl : ''"
                         height="23px"
                         alt=""
                         @click="setModal(item.product.product.name, url + item.product.product.image.contentUrl)">
                </td>
                <td>{{ item.product.warehouse.name }}</td>
                <td>
                    <span
                        class="d-inline-block text-truncate"
                        style="max-width: 150px; cursor: pointer"
                        @click="showReason(item)"
                    >
                        {{ item.details }}
                    </span>
                </td>
                <td>{{ item.amount }} {{ showUnitOfMeasure(item.product.product.unitOfMeasure) }}</td>
            </tr>
            </tbody>
        </table>
        <div v-if="getProductsInWarehousesWriteOffs.length === 0" class="col-12">{{ $t('noData') }}</div>



        <div class="row mt-3 container">
            <div class="col">
                <Pagination
                    :search="search"
                    base-url="products-in-warehouse-write-off"
                    :total-items="getProductsInWarehousesWriteOffsTotalCount"
                    method-name="searchProductInWriteOff"
                />
            </div>
        </div>

        <ModalWithPicture id="show_picture" :img="itemImageUrl" :title="itemName"/>

    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Pagination from "../../components/html/Pagination";
import ModalWithPicture from "../../components/html/ModalWithPicture";
import RowColumn from "@/components/RowColumn";
import ButtonTag from "@/components/html/ButtonTag";
import accessMixin from "@/mixin/accessMixin";
import SearchCollapse from "@/components/SearchCollapse";
import TreeCheckBox from "@/components/TreeCheckBox";
import Modal from "../../components/html/Modal";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Row from "@/components/html/Row.vue";

export default {
    name: "WriteOffList",
    components: {
        Row,
        Modal,
        ButtonTag,
        RowColumn,
        ModalWithPicture,
        Pagination,
        SearchCollapse,
        TreeCheckBox
    },
    mixins: [accessMixin, currencyFormatMixin],
    data() {
        return {
            modalItemReason: '',
            modalItemAmount: '',
            modalItemMeasure: '',
            modalItemName: '',
            itemName: '',
            itemImageUrl: '',
            url: process.env.VUE_APP_API_URL,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'productsInWarehouse.wroteOff', url: ''},
            ],
            search: {
                productName: '',
                warehouseName: '',
                minAmount: '',
                maxAmount: '',
                category: null,
                page: 1
            },
        }
    },
    computed: mapGetters([
        'getProductsInWarehousesWriteOffs',
        'getProductsInWarehousesWriteOffsTotalCount',
        'getProductCategoriesTree'
    ]),
    methods: {
        ...mapActions(['fetchProductCategoriesTree', 'searchProductInWriteOff', 'fetchProductCategoriesTree', 'setBreadcrumbItems']),
        showReason(item) {
            this.modalItemReason = item.details;
            this.modalItemAmount = item.amount;
            this.modalItemName = item.product.product.name;
            this.modalItemMeasure = item.product.product.unitOfMeasure;
            this.$bvModal.show('modal_show')
        },
        setModal(name, url) {
            this.itemName = name
            this.itemImageUrl = url
            this.$bvModal.show('show_picture')
        },
        searchProduct() {
            this.$root.showOverlay = true
            this.searchProductInWriteOff(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductInWarehousesInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchProduct()
        },
        findCategoryName(index) {
            let categoryName = ''
            let objectWarehouse = this.getProductsInWarehousesWriteOffs[index]

            if (objectWarehouse.product.product.categories.length === 0) {
                return categoryName
            }

            for (let i = 0; i < objectWarehouse.product.product.categories.length; i++) {
                categoryName = categoryName + objectWarehouse.product.product.categories[i].name + ' '
            }

            return categoryName
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchProductCategoriesTree()
    },
}
</script>

<style scoped>
.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

img {
    cursor: pointer;
}

td, th {
    text-align: center;
}

</style>